export default function mask(input: string) {
  let masked;
  // visa style card #
  masked = input.replace(/\b(?:\d{4}[ -.]?){3}(?=\d{4}\b)/g, "****");
  // amex style card #
  masked = masked.replace(/\b(?:\d{4}[ -.]?\d{6}[ -.]?)(?=\d{5}\b)/g, "****");
  // ssn #
  masked = masked.replace(/\b(?:\d{3}[ -.]?\d{2}[ -.]?)(?=\d{4}\b)/g, "****");
  return masked;
}
